@if (getAssumedUser; as assumedUser) {
  <mat-toolbar class="mat-elevation-z1">
    <ng-container>
      <mat-toolbar-row class="px-4 py-1 bg-warn fx-row x-space-between y-center" id="obo-row">
        <div class="mat-body-1 m-0">
          <!-- Impersonating user: -->
          <span>
            ACTING ON BEHALF OF: {{ assumedUser.profile?.preferredFirstName }} {{ assumedUser.profile?.preferredLastName }}
          </span>
          <!-- Email Link -->
          @if (assumedUser.profile?.preferredEmail) {
            <a [href]="'mailto:' + assumedUser.profile.preferredEmail" [style.color]="'inherit'">
              (<u>{{ assumedUser.profile.preferredEmail }}</u>)
            </a>
          }
          <!-- Metro Name -->
          @if (assumedUser.profile?.office?.metro?.metroName) {
            <span>
              - {{ assumedUser.profile?.office?.metro?.metroName }}
            </span>
          }
        </div>
        <!-- End Impersonation Button -->
        <button aria-label="Close" class="on-behalf-of" id="btn-exit-obo" mat-button (click)="endImpersonation()">
          <div class="fx-row y-center fx-gap-sm">
            <mat-icon class="material-icons-outlined">block</mat-icon>
            <span>Exit Acting Mode</span>
          </div>
        </button>
      </mat-toolbar-row>
    </ng-container>
  </mat-toolbar>
}

@if (showHeader) {
  <lc-appbar fullName="{{ firstName }} {{ lastName }}"
             [brand]="brandKey"
             [firstName]="firstName"
             [menuItems]="menuItems"
             [profilePhoto]="profilePhoto" />
}
